import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a78ba5e8295d50014ca463e_1787550396079_b733d99f/yashcomputers/src/app/student-application/page.tsx");
